<template>
  <div>
    <!-- 装修上化化，您的放心之选 -->
    <section id="img-0" class="full-image" style="background-image:url('https://obs.huahuaeco.com/official/productBg.png')">
      <div class="img-0-wrap">
        <div class="img0-content">
          <h2 class="img0-title">
            <span>装修上化化，您的放心之选</span>
          </h2>
          <p class="img0-desc">
            <span>自装&找装企随心选</span>
            <span>平台多重保障，满意为止</span>
          </p>
        </div>
        <img class="img0-img img0-qrcode" src="https://obs.huahuaeco.com/official/qrcode.png" alt="扫码体验小程序与关注官方服务号">
      </div>
    </section>

    <!-- 专属定制，帮您设计理想家 -->
    <section id="img-1" class="full-image" style="background-image:url('https://obs.huahuaeco.com/official/productBg1.png')">
      <div class="img1-content">
        <h2 class="img1-title">专属定制，帮您设计理想家。</h2>
        <p class="img1-desc">提供全流程设计服务，为您的理想家保驾护航。</p>
        <div class="rectanges">
          <div class="rectange">图纸设计</div>
          <div class="rectange">造价清单</div>
          <div class="rectange">选材建议</div>
          <div class="rectange">施工跟进</div>
          <div class="rectange">摆场指导</div>
        </div>
      </div>
      <img class="img1-img" src="https://obs.huahuaeco.com/official/product2.png" alt="">
    </section>

    <!-- 师傅手艺好，干活不马虎 -->
    <section id="img-2" class="full-image" style="background-image:url('https://obs.huahuaeco.com/official/productBg4.png')">
      <div class="img2-content">
        <h2 class="img2-title">师傅手艺好，干活不马虎。</h2>
        <p class="img2-desc">我们严选经验扎实的师傅团队，从细节到整体，把靠谱落到实处。</p>
        <div class="rectanges">
          <div class="rectange">拆除工</div>
          <div class="rectange">水电工</div>
          <div class="rectange">泥瓦工</div>
          <div class="rectange">油漆工</div>
          <div class="rectange">木工</div>
        </div>
      </div>
      <img class="img2-img" src="https://obs.huahuaeco.com/official/product3.png" alt="">
    </section>

    <!-- 自营装企，全程兜底，安心不用盯 -->
    <section id="img-3" class="full-image" style="background-image:url('https://obs.huahuaeco.com/official/productBg4.png')">
      <div class="img3-content">
        <h2 class="img3-title">自营装企，全程兜底，安心不用盯</h2>
        <p class="img3-desc">我们以自营模式把控装修全流程，让您告别“盯工地”的疲惫。</p>
        <div class="rectanges">
          <div class="rectange">客户至上</div>
          <div class="rectange">不主动增项</div>
          <div class="rectange">在线签约</div>
          <div class="rectange">规范施工</div>
          <div class="rectange">满意为止</div>
        </div>
      </div>
      <img class="img3-img" src="https://obs.huahuaeco.com/official/product4.png" alt="">
    </section>

    <!-- 平台交易保障 -->
    <section id="img-5" class="full-image" style="background-image:url('https://obs.huahuaeco.com/official/Product/img5.png')">
      <div class="img5-content">
        <h2 class="img5-title">平台交易保障</h2>
        <p class="img5-subtitle">在线交易，尊享多重保障，装修超省心</p>

        <div class="img5-grid">
          <article class="img5-card img5-card-lt">
            <h3>先装修后付款，掌握装修主动权</h3>
            <p>平台担保交易模式，客户先付款至平台，验收通过后再付款给服务方，保障业主的资金安全及主动权</p>
          </article>

          <article class="img5-card img5-card-rt">
            <h3>关键数据留痕，装修维权不再难</h3>
            <p>在线沟通记录、报价方案、电子签约、变更记录、交底记录、验收记录、售后记录等关键数据留存平台，维权不再困难</p>
          </article>

          <div class="img5-center" aria-hidden="true">
            <img src="https://obs.huahuaeco.com/official/Product/img5safe.png" alt="平台交易保障" />
          </div>

          <article class="img5-card img5-card-lb">
            <h3>售后保障服务，解决您的后顾之忧</h3>
            <p>服务方按约定承担售后服务，未履行时将受到平台严厉处罚，将有效保障业主权益</p>
          </article>

          <article class="img5-card img5-card-rb">
            <h3>平台托底保障，服务至满意为止</h3>
            <p>业主不满意服务商且协商不成时，可申请平台托底服务，平台自营团队接管服务，服务至满意为止</p>
          </article>
        </div>
      </div>
    </section>

    <!-- 在线交易流程 -->
    <!-- <section id="img-6" class="full-image img6-section" :style="img6Active === 'left' ? { backgroundImage: 'url(https://obs.huahuaeco.com/official/Product/img6Left.png)' } : { backgroundImage: 'url(https://obs.huahuaeco.com/official/Product/img6Right.png)' }">
      <div class="img6-title1">在线交易流程</div>
      <div class="img6-title2">两种下单模式随心选，均可享平台保障</div>
      <div class="img6-toggle" aria-hidden="false">
        <button class="img6-btn left" @click.stop.prevent="setImg6('left')" aria-label="切换为左图"></button>
        <button class="img6-btn right" @click.stop.prevent="setImg6('right')" aria-label="切换为右图"></button>
      </div>
    </section> -->

    <section id="img-6" class="full-image img6-section" :style="img6Active === 'left' ? { backgroundImage: 'url(https://obs.huahuaeco.com/official/img6Left.png)' } : { backgroundImage: 'url(https://obs.huahuaeco.com/official/img6Right.png)' }">
      <div class="img6-title1">在线交易流程</div>
      <div class="img6-title2">两种下单模式随心选，均可享平台保障</div>
      <div class="img6-toggle" aria-hidden="false">
        <button class="img6-btn left" @click.stop.prevent="setImg6('left')" aria-label="切换为左图"></button>
        <button class="img6-btn right" @click.stop.prevent="setImg6('right')" aria-label="切换为右图"></button>
      </div>

      <div class="img-6-wrap">
        <img v-if="img6Active === 'left'" src="https://obs.huahuaeco.com/official/img6LeftImgs.png" alt="">
        <img v-else src="https://obs.huahuaeco.com/official/img6RightImgs.png" alt="">
      </div>
    </section>

    <!-- 立即体验 -->
    <section id="img-7" class="full-image img7-section">
      <div class="img7-title1">立即体验</div>
      <div class="img7-title2">我们致力于服务至业主满意为止，不负每个客户的信任</div>

      <img class="img7-img" src="https://obs.huahuaeco.com/official/product1.png" alt="">
    </section>

    <SeoStaticImages :images="seoImages" />
  </div>
</template>

<script>
import { useHead } from '@unhead/vue'
import { getPageHead } from '../utils/page-head'
import SeoStaticImages from '../components/SeoStaticImages.vue'
export default {
  name: 'ProductPage',
  components: {
    SeoStaticImages
  },
    setup() {
    useHead(getPageHead('decorationServices'))
  },
  data() {
    return {
      seoImages: [
        'https://obs.huahuaeco.com/official/productBg.png',
        'https://obs.huahuaeco.com/official/productBg1.png',
        'https://obs.huahuaeco.com/official/productBg4.png',
        'https://obs.huahuaeco.com/official/Product/img5.png',
        'https://obs.huahuaeco.com/official/img6Left.png',
        'https://obs.huahuaeco.com/official/img6Right.png',
        'https://obs.huahuaeco.com/official/img6LeftImgs.png',
        'https://obs.huahuaeco.com/official/img6RightImgs.png',
        'https://obs.huahuaeco.com/official/Product/product_rectangle.png'
      ],
      imgList: [
        { url: 'https://obs.huahuaeco.com/official/Product/img1e.png', alt: '专属定制，帮您设计理想家', msg: '提供全流程设计服务，为您的理想家保驾护航', 
          tags: ['图纸设计','造价清单','选材建议','施工跟进','摆场指导']
        },
        { url: 'https://obs.huahuaeco.com/official/Product/img2e.png', alt: '师傅手艺好，干活不马虎', msg: '我们严选经验扎实的师傅团队，从细节到整体，把靠谱落到实处',
          tags: ['拆除工','水电工','泥瓦工','油漆工','木工']
         },
        { url: 'https://obs.huahuaeco.com/official/Product/img3e.png', alt: '自营装企，全程兜底，安心不用盯', msg: '我们以自营模式把控装修全流程，让您告别 “盯工地” 的疲惫',
          tags: ['客户至上','不主动增项','在线签约','规范施工','满意为止']
        },
      ],
      img6Active: 'left',
      showFooter: true
    }
  },
  methods: {
    setImg6(side) {
      this.img6Active = side
    },
    handleScroll() {
      const img6 = document.getElementById('img-6')
      if (!img6) {
        this.showFooter = true
        return
      }
      const scrollY = window.pageYOffset || document.documentElement.scrollTop || window.scrollY || 0
      const img6Top = img6.getBoundingClientRect().top + scrollY
      // 当滚动到 img-6 的顶部或更低位置时，隐藏页脚
      this.showFooter = scrollY < img6Top - 500
    }
  }
  ,
  mounted() {
    this.handleScroll()
    this._boundHandleScroll = this.handleScroll.bind(this)
    window.addEventListener('scroll', this._boundHandleScroll, { passive: true })
  },
  beforeUnmount() {
    if (this._boundHandleScroll) {
      window.removeEventListener('scroll', this._boundHandleScroll)
    }
  }
}
</script>

<style scoped lang="scss">
.img-6-wrap {
  display: flex;
  justify-content: center;
  position: absolute;
  top: 5rem;
  left: 50%;
  transform: translateX(-50%);
  width: 90%;
  img {
    width: 80%;
    height: auto;
    display: block;
  }
}
.hero {
  height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  padding: 98px;
  text-align: center;
  position: relative;
  overflow: hidden;

  &-bg {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center center;
    z-index: 0;
    pointer-events: none;
  }

  > :not(.hero-bg) {
    position: relative;
    z-index: 1;
  }
}

.header-code {
  width: 736px;
  height: 397px;
  margin: 0 auto;
  background-image: url('https://obs.huahuaeco.com/official/qrcode.png');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}

.content-section {
  min-height: 900px;
  padding-top: 180px;

  &::before {
    content: "";
    display: block;
    height: 0;
  }
}

.box-wrapper {
  max-width: var(--container-width);
  margin: 0 auto;
  text-align: left;

  &.text-right {
    text-align: right;

    .section-elem {
      justify-content: flex-end;
    }
  }
}

.section-inner {
  display: flex;
}

.section-title {
  font-size: 64px;
  margin: 0 0 42px;
  color: #0b1220;
}

.section-desc {
  font-size: 24px;
  color: #475569;
  margin: 0 0 12px;
  line-height: 1.8;

  &.muted {
    color: #6b7280;
  }
}

.section-elem {
  img {
    width: 100%;
    height: auto;
    margin-top: 120px;
  }
}

.tags {
  list-style: none;
  padding: 0;
  margin: 30px 0 0;
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}

.tag {
  background: linear-gradient(180deg, #78c9fd, #4e94fc);
  color: #ffffff;
  padding: 12px 32px;
  border-radius: 24px;
  font-size: 24px;
  margin-bottom: 20px;
}

.img6-section {
  position: relative;
  min-height: 86vh;
  background-size: cover;
  background-position: center center;
  display: block;
  transition: background-image 0.4s ease, background-position 0.4s ease;
  padding-top: 60px;
  .img6-title1 {
    color: #262626;
    text-align: center;
    font-size: 40px;
    font-weight: 600;
    margin-bottom: 20px;
  }
  .img6-title2 {
    color: #595959;
    text-align: center;
    font-size: 24px;
  }
}

.img6-toggle {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 25%;
  z-index: 95;
  display: flex;
  pointer-events: auto;
}

.img6-btn {
  width: 188px;
  height: 72px;
  background: transparent;
  border: 0;
  opacity: 0;
  cursor: pointer;
}

.img7-section {
  padding-top: 100px;
  .img7-title1 {
    color: #262626;
    text-align: center;
    font-size: 40px;
    font-weight: 600;
    margin-bottom: 20px;
  }
  .img7-title2 {
    color: #595959;
    text-align: center;
    font-size: 24px;
  }
}

#img-7 {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 0 !important;
  min-height: 80vh !important;
  height: 8rem;
}
.img7-img {
  width: 6.6667rem;
  margin-top: 60px;
}

#img-1 {
  padding: 0 clamp(24px, 18vw, 200px);
  background-position: center;
  position: relative;
}

#img-2 {
  display: flex;
  align-items: center;
  padding: 0 clamp(24px, 18vw, 200px);
  background-position: center;
}

#img-3 {
  display: flex;
  align-items: center;
  padding: 0 clamp(24px, 18vw, 200px);
  background-position: center;
}

#img-5 {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
  background-position: center;
}

#img-0 {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  height: auto !important;
  min-height: 100vh;
  min-height: 100svh;
  padding: 180px 24px 90px;
  box-sizing: border-box;
}

.img-0-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 0;
  .img0-content {
    text-align: center;
  }
  .img0-img {
    width: 6.6667rem;
    margin-top: 60px;
  }
  .img0-qrcode {
    width: min(9rem, 82vw);
    height: auto;
  }
  .img0-title {
    margin: 0;
    color: #262626;
    font-size: 48px;
    font-weight: 600;
    line-height: 1.35;

    span {
      display: block;
    }
  }

  .img0-desc {
    margin: 34px 0 0;
    color: #595959;
    font-size: 20px;
    line-height: 1.8;

    span {
      display: block;
    }
  }
}


.img1-content {
  max-width: 760px;
  margin: 0;
  text-align: left;
  z-index: 1;
  position: absolute;
  top: 2rem;
}
.img1-img {
  width: 8rem;
  position: absolute;
  z-index: 0;
  bottom: 2rem;
  right: 2rem;
}
.img2-img {
  width: 8rem;
  position: absolute;
  z-index: 0;
  bottom: 2rem;
  left: 2rem;
}
.img3-img {
  width: 12rem;
  position: absolute;
  z-index: 0;
  bottom: 2rem;
  right: 2rem;
}

.img1-title {
  margin: 0;
  color: #262626;
  font-size: 48px;
  font-weight: 600;
  line-height: 1.35;
}

.img1-desc {
  margin: 24px 0 0;
  color: #8c8c8c;
  font-size: 24px;
  line-height: 1.7;
}

.img2-content {
  max-width: 900px;
  margin: 0 0 0 auto;
  text-align: right;
  margin-top: -340px;
  z-index: 1;
  .rectanges {
    width: 700px;
    display: flex;
    justify-content: flex-end;
  }
}

.img2-title {
  margin: 0;
  color: #262626;
  font-size: 48px;
  font-weight: 600;
  line-height: 1.35;
}

.img2-desc {
  margin: 24px 0 0;
  color: #8c8c8c;
  font-size: 24px;
  line-height: 1.7;
}

.img3-content {
  max-width: 760px;
  margin: 0;
  text-align: left;
  position: absolute;
  z-index: 1;
  top: 2rem;
}

.img3-title {
  margin: 0;
  color: #262626;
  font-size: 48px;
  font-weight: 600;
  line-height: 1.35;
}

.img3-desc {
  margin: 24px 0 0;
  color: #8c8c8c;
  font-size: 24px;
  line-height: 1.7;
}

.img5-content {
  width: min(1220px, 100%);
  margin: 0 auto;
}

.img5-title {
  margin: 0;
  text-align: center;
  color: #262626;
  font-size: 48px;
  font-weight: 600;
  line-height: 1.25;
}

.img5-subtitle {
  margin: 24px 0 0;
  text-align: center;
  color: #8c8c8c;
  font-size: 24%;
  line-height: 1.45;
  font-size: 24px;
}

.img5-grid {
  margin-top: 66px;
  display: grid;
  grid-template-columns: minmax(280px, 1fr) 300px minmax(280px, 1fr);
  grid-template-areas:
    "lt center rt"
    "lb center rb";
  align-items: center;
  column-gap: clamp(24px, 3.8vw, 56px);
  row-gap: 36px;
}

.img5-card-lt { grid-area: lt; }
.img5-card-rt { grid-area: rt; }
.img5-card-lb { grid-area: lb; }
.img5-card-rb { grid-area: rb; }

.img5-card {
  background: rgba(255, 255, 255, 0.8);
  border-radius: 20px;
  padding: 34px 30px;

  h3 {
    margin: 0;
    color: #3a3a3a;
    font-size: 22px;
    line-height: 1.35;
  }

  p {
    margin: 18px 0 0;
    color: #8c8c8c;
    font-size: 16px;
    line-height: 1.55;
  }
}

.img5-center {
  grid-area: center;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 100%;
    max-width: 360px;
    height: auto;
    display: block;
  }

  
}


.rectanges {
  margin-top: 28px;
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}

.rectange,
.reactange {
  width: 160px;
  height: 60px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-image: url('https://obs.huahuaeco.com/official/Product/product_rectangle.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 8px;
  color: #262626;
  font-size: 24px;
  color: #fff;
}

@media (max-width: 1300px) {
  #img-0 {
    padding: 120px 40px 90px;
  }

  .img1-img {
    width: 6rem;
    bottom: 1.2rem;
    right: 1rem;
  }
  .img2-img {
    width: 7rem;
    bottom: 1.3rem;
    left: 1rem;
  }
  .img3-img {
    width: 9rem;
    bottom: 2.2rem;
    right: 1rem;
  }
  #img-9 .bottom-top .right {
    justify-content: flex-start !important;
  }

  .img5-center {
    img {
      max-width: 240px;
    }
  }
  .img5-card {
    padding: 10px 10px;
  }
  .img5-grid {
    column-gap: 12px;
    grid-template-columns: minmax(280px, 1fr) 180px minmax(280px, 1fr)
  }
  .grid-template-columns {
    
  }
  .img2-content {
    .rectanges {
      padding-right: 60px;
    }
    .img2-desc {
      padding-right: 100px;
    }
    .img2-title {
      padding-right: 50px;
    }
  }
}

@media (max-width: 1600px) {
  #img-1,
  #img-2,
  #img-3 {
    display: grid !important;
    align-items: center;
    column-gap: clamp(36px, 4vw, 64px);
    height: auto !important;
    min-height: clamp(620px, 54vw, 760px) !important;
    padding: clamp(72px, 7vw, 110px) clamp(48px, 8vw, 110px) !important;
    overflow: hidden;
  }

  #img-1,
  #img-3 {
    grid-template-columns: minmax(0, 680px) minmax(300px, 520px);
  }

  #img-2 {
    grid-template-columns: minmax(300px, 500px) minmax(0, 700px);
  }

  #img-1 .img1-content,
  #img-3 .img3-content {
    grid-column: 1;
  }

  #img-2 .img2-content {
    grid-column: 2;
  }

  #img-1 .img1-img,
  #img-3 .img3-img {
    grid-column: 2;
  }

  #img-2 .img2-img {
    grid-column: 1;
  }

  #img-1 .img1-content,
  #img-2 .img2-content,
  #img-3 .img3-content {
    position: relative !important;
    grid-row: 1;
    top: auto !important;
    right: auto !important;
    bottom: auto !important;
    left: auto !important;
    transform: none !important;
    margin: 0 !important;
    padding: 0 !important;
    width: auto !important;
    max-width: 700px !important;
    z-index: 2;
  }

  #img-1 .img1-img,
  #img-2 .img2-img,
  #img-3 .img3-img {
    position: relative !important;
    grid-row: 1;
    top: auto !important;
    right: auto !important;
    bottom: auto !important;
    left: auto !important;
    transform: none !important;
    width: min(100%, 520px) !important;
    height: auto !important;
    justify-self: center;
    align-self: end;
    z-index: 1;
  }

  #img-3 .img3-img {
    width: min(100%, 560px) !important;
  }

  #img-1 .rectanges,
  #img-2 .rectanges,
  #img-3 .rectanges {
    width: auto !important;
    max-width: 700px;
    padding: 0 !important;
    gap: 16px;
  }

  #img-1 .rectanges,
  #img-3 .rectanges {
    justify-content: flex-start;
  }

  #img-2 .rectanges {
    justify-content: flex-end;
  }

  #img-2 .img2-title,
  #img-2 .img2-desc {
    padding-right: 0 !important;
  }

  .rectange,
  .reactange {
    width: clamp(140px, 10vw, 160px);
    height: 60px;
    font-size: clamp(20px, 1.7vw, 24px);
  }
}

@media (max-width: 1100px) {
  #img-0 {
    padding: 96px 28px 72px;
  }

  #img-1,
  #img-2,
  #img-3 {
    grid-template-columns: 1fr !important;
    row-gap: 34px;
    min-height: auto !important;
    padding: 64px 36px 0 !important;
  }

  #img-1 .img1-content,
  #img-2 .img2-content,
  #img-3 .img3-content {
    grid-column: 1;
    grid-row: 1;
    max-width: 720px !important;
    justify-self: center;
    text-align: center;
  }

  #img-1 .img1-img,
  #img-2 .img2-img,
  #img-3 .img3-img {
    grid-column: 1;
    grid-row: 2;
    width: min(520px, 82vw) !important;
  }

  #img-1 .rectanges,
  #img-2 .rectanges,
  #img-3 .rectanges {
    justify-content: center;
    margin-left: auto;
    margin-right: auto;
  }
}
</style>
